import { render, staticRenderFns } from "./LearningCenter.vue?vue&type=template&id=ef8854b2&scoped=true"
import script from "./LearningCenter.vue?vue&type=script&lang=js"
export * from "./LearningCenter.vue?vue&type=script&lang=js"
import style0 from "./LearningCenter.vue?vue&type=style&index=0&id=ef8854b2&prod&lang=scss"
import style1 from "./LearningCenter.vue?vue&type=style&index=1&id=ef8854b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8854b2",
  null
  
)

export default component.exports